import Axios from "./axios";

const resource = "reseller-how-it-works";

export default {
  get(params) {
		return Axios.get(`${resource}`, params);
	}
}